import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  addLevel (params) {
    return axios.post(global.EURLATE_MEMBER + '/memberLevel/insertMemberLevel', params)
  },
  updateLevel (params) {
    return axios.post(global.EURLATE_MEMBER + '/memberLevel/updateMemberLevel', params)
  },
  deleteLevel (params) {
    return axios.post(global.EURLATE_MEMBER + '/memberLevel/deleteMemberLevel', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/mmc/memberLevel.js